import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import AnalyzerSelectLocal from 'features/analyzers/AnalyzerSelectLocal';
import SnapshotSelectLocal from 'features/snapshots/SnapshotSelectLocal';
import { Control, Controller, UseFormWatch } from 'react-hook-form';
import { useAnalyzersByLocation } from 'features/locations/api/getAnalyzersByLocation';
import { useSnapshots } from 'features/snapshots/api/getSnapshots';

interface Props {
  control: Control<{
    location_id: number;
    dish_id: number;
    duration: number;
    analyzerId: number;
    snapshotId: number;
  }>;
  watch: UseFormWatch<{
    location_id: number;
    dish_id: number;
    duration: number;
    analyzerId: number;
    snapshotId: number;
  }>;
  generateDisabled: boolean;
  handleSubmit: () => void;
}

const ForecastReflectionGenerationForm = ({
  control,
  watch,
  generateDisabled,
  handleSubmit,
}: Props) => {
  const { data: analyzers } = useAnalyzersByLocation({
    locationId: watch('location_id'),
  });
  const { data: snapshots } = useSnapshots({ analyzerId: watch('analyzerId') });

  return (
    <Grid
      item
      container
      alignItems='center'
      spacing={1}
      xs
      justifyContent='flex-end'
      wrap='nowrap'
    >
      <Controller
        name='duration'
        control={control}
        render={({ field: { onChange, value } }) => (
          <Grid item style={{ minWidth: '10rem' }}>
            <FormControl fullWidth>
              <InputLabel id='duration-select-label'>
                Analysis Duration
              </InputLabel>
              <Select
                labelId='duration-select-label'
                label='Analysis Duration'
                id='duration'
                name='duration'
                onChange={(e) => onChange(e.target.value)}
                value={value}
              >
                <MenuItem key='1' value={'1'}>
                  3 Months
                </MenuItem>
                <MenuItem key='2' value={'2'}>
                  6 Months
                </MenuItem>
                <MenuItem key='3' value={'3'}>
                  1 Year
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        )}
      />
      <Grid item style={{ width: '150px' }}>
        <Controller
          name='analyzerId'
          control={control}
          rules={{ required: true, validate: (value) => value !== -1 }}
          render={({ field: { onChange, value } }) => (
            <AnalyzerSelectLocal
              analyzers={analyzers}
              selectedAnalyzerId={value}
              handleAnalyzerChanged={(e) => onChange(e.target.value)}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item style={{ width: '150px' }}>
        <Controller
          name='snapshotId'
          control={control}
          rules={{ required: true, validate: (value) => value !== -1 }}
          render={({ field: { onChange, value } }) => (
            <SnapshotSelectLocal
              snapshots={snapshots}
              selectedSnapshotId={value}
              handleSnapshotChanged={onChange}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item>
        <Button
          variant='contained'
          onClick={handleSubmit}
          disabled={generateDisabled}
        >
          Generate
        </Button>
      </Grid>
    </Grid>
  );
};

export default ForecastReflectionGenerationForm;
